/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { CircularProgress, Paper, Typography, Divider, Chip, Button } from '@material-ui/core'

import Action from '../../../../fluid/Actions/ActionFactory';

import dqm_config from './DQMConfig';
import DataSource from '../components/DataSource';

import { v4 as uuidv4 } from 'uuid';

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

const data_source_temp = {
    name : '',
    database_name : '',
    dimension_values : [
        {
            name : 'uniqueness',
            value : ''
        },
        {
            name : 'completeness',
            value : ''
        },
        {
            name : 'accuracy',
            value : ''
        },
        {
            name : 'validity', 
            value : ''
        },
        {
            name : 'consistency',
            value : ''
        },
        {
            name : 'compliance',
            value : ''
        }
    ],
    fields : []
}

class DQMConfigurator extends Component {
    state = {
        config : null,
        loading_config : false,
        config_error : false,
        updating_config : false
    }

    componentDidMount () {
        this.getConfig()
    }

    getConfig = () => {
        this.setState({...this.state, loading_config : true, config_error : false}, () => {
            Action('http_request', {
                url : "/sainapse/configuration/dqm_dash_config",
                method : "get",
                data : {}
            }).then(res => {
                console.log('DQM Config : ', res)
                this.setState({...this.state, config : res.data.result.config.dqm_config, loading_config : false, config_error : false})
            }).catch(err => {
                Action('http_request', {
                    url : "/sainapse/configuration/",
                    method : "post",
                    data : {
                        name : "dqm_dash_config",
                        config : {
                            dqm_config : dqm_config
                        }
                    }
                }).then(res => {
                    console.log('DQM Config : ', res)
                    Action('http_request', {
                        url : "/sainapse/configuration/dqm_dash_config",
                        method : "get",
                        data : {}
                    }).then(res => {
                        console.log('DQM Config : ', res)
                        this.setState({...this.state, config : res.data.result.config.dqm_config, loading_config : false, config_error : false})
                    }).catch(err => {
                        this.setState({...this.state, config : null, loading_config : false, config_error : true})
                    })
                })
            })
        })
    }

    updateConfig = () => {
        this.setState({...this.state, updating_config : true}, () => {
            Action('http_request', {
                url : "/sainapse/configuration/dqm_dash_config",
                method : "put",
                data : {
                    config : {
                        dqm_config : this.state.config
                    }
                }
            }).then(res => {
                console.log('DQM Updated Config : ', res)
            })
        })
    }

    renderDimensions = () => {
        return (
            <Paper style = {{paddingTop : '10px'}} square>
                <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2'>Dimensions</Typography>
                <Divider style = {{marginBottom : '5px', marginTop : '5px'}}/>
                <div>
                    {this.state.config.dimensions.map(dimension => {
                        return (
                            <Chip
                                style = {{margin : '10px'}}
                                label = {dimension.display}
                                color = 'primary'
                            />
                        )
                    })}
                </div>
            </Paper>
        )
    }

    renderDataSources = () => {
        if (this.state.config.data_sources.length > 0) {
            return (
                <Paper style = {{marginTop : '10px', padding : '10px'}} square>
                    <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2'>Data Sources</Typography>
                    <Divider style = {{marginBottom : '5px', marginTop : '5px'}}/>
                    <div style = {{margin : '10px'}}>
                        {this.state.config.data_sources.map(data_source => {
                            return (
                                <DataSource 
                                    key = {data_source.id}
                                    config = {data_source}
                                    dimensions = {this.state.config.dimensions}
                                    update_source = {(data_source) => this.updateDataSource(data_source)}
                                    delete_source = {(data_source) => this.deleteDataSource(data_source)}
                                />
                            )
                        })}
                    </div>
                    <Button
                        variant = 'contained'
                        color = 'primary'
                        size = 'small'
                        onClick = {this.addDataSource}
                    >Add Data Source</Button>
                </Paper>
            )
        } else {
            return (
                <Paper style = {{marginTop : '10px', padding : '10px'}} square>
                    <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2'>Data Sources</Typography>
                    <Divider style = {{marginBottom : '5px', marginTop : '5px'}}/>
                    <Typography style = {{margin: '10px'}} display='block' variant = 'caption'>No Data Sources Added</Typography>
                    <Button
                        variant = 'contained'
                        color = 'primary'
                        size = 'small'
                        onClick = {this.addDataSource}
                    >Add Data Source</Button>
                </Paper>
            )
        }
        
    }

    updateDataSource = (data_source) => {
        let config = {...this.state.config}
        let data_source_index = config.data_sources.findIndex(ds => ds.id === data_source.id)
        if (data_source_index !== -1) {
            config.data_sources[data_source_index] = data_source
            this.setState({...this.state, config : config})
        }
    }

    deleteDataSource = (data_source) => {
        let config = {...this.state.config}
        let data_source_index = config.data_sources.findIndex(ds => ds.id === data_source.id)
        if (data_source_index !== -1) {
            config.data_sources.splice(data_source_index, 1)
            this.setState({...this.state, config : config})
        }
    }

    addDataSource = () => {
        let config = {...this.state.config}
        let new_data_source = {...data_source_temp}
        new_data_source.id = uuidv4()
        config.data_sources.push(new_data_source)
        this.setState({...this.state, config : config})
    }

    renderConfig = () => {
        if (this.state.loading_config) {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress variant='indeterminate' color = 'primary'/>
                </div>
            )
        } else if (this.state.config_error) {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography variant = 'body2' color = 'secondary'>Error loading dashboard configuration</Typography>
                </div>
            )
        } else if (this.state.config !== null) {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 100px)', padding : '10px'}}>
                    {this.renderDimensions()}
                    {this.renderDataSources()}
                </div>
            )
        }
    }


    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper square style = {{width : '100vw', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography variant = 'button' style = {{marginLeft : '10px', flexGrow: 1}}>DQM Dashboard Configuration</Typography>
                    <Button
                        style = {{marginRight : '10px'}}
                        variant = 'contained'
                        size = 'small'
                        color = 'primary'
                        onClick = {this.updateConfig}
                    >Submit</Button>
                </Paper>
                {this.renderConfig()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(DQMConfigurator);